/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Defines how the agent handles a volume when the owning application is removed.
 */
export enum ApplicationVolumeReclaimPolicy {
  RETAIN = 'Retain',
}
